import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = '';

export const getContragentAllDataSlice = createSlice({
 name: 'getContragentAllData',
 initialState,
 reducers: {
  getContragentAllData: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { getContragentAllData } = getContragentAllDataSlice.actions;

export default getContragentAllDataSlice.reducer;
